<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { serviceFeePriceDisplay } from '@/utils/serviceFeeViewUtils.js';

const { t } = useI18n();

const props = defineProps({
  serviceFees: {
    type: Array,
    required: true,
  },
  // hide the action column for a read only view (later reloaded use)
  editable: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['edit', 'remove']);

const tableHeader = computed(() => {
  const header = [
    { title: t('serviceFees.period'), value: 'period' },
    { title: t('serviceFees.billingVariant'), value: 'billingVariant' },
    { title: t('serviceFees.price'), value: 'price' },
    { title: t('serviceFees.note'), value: 'note' },
  ];
  if (props.editable)
    header.push({ title: t('actions'), value: 'actions', sortable: false });
  return header;
});

function formatDate(value) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('de-AT');
}

const rows = computed(() => props.serviceFees.map((fee, index) => ({
  index,
  period: formatDate(fee.dateStart) + ' - ' + (fee.dateEnd ? formatDate(fee.dateEnd) : t('serviceFees.openEnd')),
  billingVariant: fee.billingVariant,
  price: serviceFeePriceDisplay(fee),
  note: fee.note || '',
})));
</script>

<template>
  <v-data-table
    class="elevation-2 mainViewContent"
    :headers="tableHeader"
    :items="rows"
    :items-per-page="25"
    density="comfortable"
  >
    <template v-slot:[`item.billingVariant`]="{ value }">
      {{ value ? t(`serviceFees.billingVariants.${value}`) : '' }}
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon
        class="mr-2"
        :title="t('edit')"
        @click="emit('edit', item.index)"
      >mdi-pencil</v-icon>
      <v-icon
        :title="t('delete')"
        @click="emit('remove', item.index)"
      >mdi-delete</v-icon>
    </template>
  </v-data-table>
</template>
